import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import settingsEn from './locales/en/settings.json';
import settingsFr from './locales/fr/settings.json';
import settingsHt from './locales/ht/settings.json';
import commonEn from './locales/en/common.json';
import commonFr from './locales/fr/common.json';
import commonHt from './locales/ht/common.json';
import authEn from './locales/en/auth.json';
import authFr from './locales/fr/auth.json';
import authHt from './locales/ht/auth.json';
import dashboardEn from './locales/en/dashboard.json';
import dashboardFr from './locales/fr/dashboard.json';
import dashboardHt from './locales/ht/dashboard.json';
import servicesEn from './locales/en/services.json';
import servicesFr from './locales/fr/services.json';
import servicesHt from './locales/ht/services.json';
import transactionsEn from './locales/en/transactions.json';
import transactionsFr from './locales/fr/transactions.json';
import transactionsHt from './locales/ht/transactions.json';
import walletEn from './locales/en/wallet.json';
import walletFr from './locales/fr/wallet.json';
import walletHt from './locales/ht/wallet.json';
import messagesEn from './locales/en/messages.json';
import messagesFr from './locales/fr/messages.json';
import messagesHt from './locales/ht/messages.json';
import infoEn from './locales/en/info.json';
import infoFr from './locales/fr/info.json';
import infoHt from './locales/ht/info.json';
import qrcodeEn from './locales/en/qrcode.json';
import qrcodeFr from './locales/fr/qrcode.json';
import qrcodeHt from './locales/ht/qrcode.json';
import accountsEn from './locales/en/accounts.json';
import accountsFr from './locales/fr/accounts.json';
import accountsHt from './locales/ht/accounts.json';
import solideEn from './locales/en/solide.json';
import solideFr from './locales/fr/solide.json';
import solideHt from './locales/ht/solide.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                settings: settingsEn,
                common: commonEn,
                auth: authEn,
                dashboard: dashboardEn,
                services: servicesEn,
                transactions: transactionsEn,
                wallet: walletEn,
                messages: messagesEn,
                info: infoEn,
                qrcode: qrcodeEn,
                accounts: accountsEn,
                solide: solideEn,
            },
            fr: {
                settings: settingsFr,
                common: commonFr,
                auth: authFr,
                dashboard: dashboardFr,
                services: servicesFr,
                transactions: transactionsFr,
                wallet: walletFr,
                messages: messagesFr,
                info: infoFr,
                qrcode: qrcodeFr,
                accounts: accountsFr,
                solide: solideFr,
            },
            ht: {
                settings: settingsHt,
                common: commonHt,
                auth: authHt,
                dashboard: dashboardHt,
                services: servicesHt,
                transactions: transactionsHt,
                wallet: walletHt,
                messages: messagesHt,
                info: infoHt,
                qrcode: qrcodeHt,
                accounts: accountsHt,
                solide: solideHt,
            },
        },
        fallbackLng: 'ht',
        debug: false,
        detection: {
            order: ['localStorage', 'cookie', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage', 'cookie'],
        },
        interpolation: {
            escapeValue: false,
        },
        ns: ['settings', 'common', 'auth', 'dashboard', 'services', 'transactions', 'wallet', 'messages', 'info', 'qrcode', 'accounts', 'solide'],
        defaultNS: 'common',
        fallbackNS: ['transactions', 'accounts', 'solide', 'services', 'auth'],
    });

export default i18n;
